<template>
  <div>
    <div v-if="product.properties.variants && product.properties.variants.length" class="uppercase font-bold text-xs mb-1 tracking-widest">
      Trouvez le modèle qu'il vous faut!
    </div>
    <div class="flex flex-wrap mb-4">
      <div
        v-for="(variant, index) in variants"
        :key="variant.feature_id"
        class="w-full lg:w-1/2 mb-2"
        :class="index % 2 ? 'pl-1' : 'pr-1'"
      >
        <variant-menu
          :variants="variant.products"
          @click:variant="$gtmEvents.onActivatedVariant(product, {feature_name: variant.feature_name, value: $event.value && $event.value.name ? $event.value.name : $event.value})"
        >
          <template #label>
            {{ variant.feature_name }}
          </template>
          <template #current>
            <decorated-feature-value :value="variant.current_value" />
          </template>
          <template #item="{ item }">
            <decorated-feature-value :value="item.value" />
          </template>
        </variant-menu>
      </div>
    </div>
  </div>
</template>

<script>
import orderBy from 'lodash.orderby'
import DecoratedFeatureValue from '../general/DecoratedFeatureValue'
import VariantMenu from './VariantMenu'

export default {
  components: {
    VariantMenu,
    DecoratedFeatureValue
  },
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  computed: {
    variants () {
      return orderBy(this.product.properties.variants, ['feature_name'], ['asc'])
    }
  }
}
</script>
